
var ReactNative = require('react-native');
var {
  Linking,
} = ReactNative;

module.exports = {
  getLaunchedURL : function(completion)
  {
    var url = Linking.getInitialURL().then((url) =>
    {
      if( completion ) completion(url);
    }).catch(err => console.error('An error occurred', err));
  },
  addEventListener : function(responder)
  {
    Linking.addEventListener('url', responder);
  },
  removeEventListener : function(responder) {
    Linking.removeEventListener('url', responder);
  }
}



// WEBPACK FOOTER //
// ./src/wrappers/DeepLinkManager.js